import { render, staticRenderFns } from "./LoginForm2.vue?vue&type=template&id=afedfd7c&scoped=true&"
import script from "./LoginForm2.vue?vue&type=script&lang=js&"
export * from "./LoginForm2.vue?vue&type=script&lang=js&"
import style0 from "./LoginForm2.vue?vue&type=style&index=0&id=afedfd7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afedfd7c",
  null
  
)

export default component.exports